export const WIDTH_ID = 13;
export const LENGTH_ID = 14;
export const WEIGHT_ID = 15;
export const COST_ID = 17;
export const NUMBER_OF_PRODUCTS_ID = 20;
export const DENSITY_ID = 22;
export const PERCENT_USED_ID = 23;
export const AVERAGE_DENSITY_ID = 24;
export const COST_ADDON_ID = 25;
export const PERCENT_WASTE_ID = 26;
export const VOLUME_ID = 28;
export const CLASS_ID = 29;
export const HEIGHT_ID = 30;
export const WEIGHT_ADDON_ID = 31;
export const COST_PER_METRICTON_ID = 34;
export const MATERIAL_COST_ID = 35;
export const CONVERSION_COST_ID = 36;
export const CALCULATED_COST_ID = 39;
